module.exports = __webpack_public_path__ + "static/img/200054.2b357dd4.png";